import * as Yup from "yup";

type TFunc = (key: string, options?: Record<string, unknown>) => string;

export const VIMEO_SOURCE_TYPE = "vimeo";

export const S3_SOURCE_TYPE = "s3";

export const createVideoElementFormSchema = (t: TFunc) =>
	Yup.object({
		title: Yup.string().required(t("validation:titleFieldRequired")),
		sourceType: Yup.string()
			.oneOf([VIMEO_SOURCE_TYPE, S3_SOURCE_TYPE])
			.required(t("validation:videoSourceTypeFieldRequired")),
		vimeoId: Yup.string().when("sourceType", {
			is: VIMEO_SOURCE_TYPE,
			then: (schema) => schema.required(t("validation:videoFieldRequired")),
			otherwise: (schema) => schema.optional(),
		}),
		videoSourceId: Yup.string().when("sourceType", {
			is: VIMEO_SOURCE_TYPE,
			then: (schema) => schema.required(t("validation:videoSourceFieldRequired")),
			otherwise: (schema) => schema.optional(),
		}),
		folder: Yup.string()
			.trim()
			.when("sourceType", {
				is: S3_SOURCE_TYPE,
				then: (schema) => schema.required(t("validation:videoFolderFieldRequired")),
				otherwise: (schema) => schema.optional(),
			}),
	});

export const createSourceTypeOptions = (
	t: TFunc,
	availableSourceTypes: readonly string[],
	savedSourceType: string,
) =>
	[
		{ value: VIMEO_SOURCE_TYPE, label: t("educationalOffer.sourceTypeVimeo") },
		{ value: S3_SOURCE_TYPE, label: t("educationalOffer.sourceTypeS3") },
	].filter(
		(option) => availableSourceTypes.includes(option.value) || option.value === savedSourceType,
	);

export const getInitialSourceType = (
	videoSource: { sourceType: string; vimeoId?: string | null },
	availableSourceTypes: readonly string[],
) => {
	if (videoSource.sourceType === S3_SOURCE_TYPE) return S3_SOURCE_TYPE;

	const isUnsetVimeoSource = !videoSource.vimeoId;

	return isUnsetVimeoSource && availableSourceTypes.includes(S3_SOURCE_TYPE)
		? S3_SOURCE_TYPE
		: VIMEO_SOURCE_TYPE;
};
